/**
 * AI 90 DAY IMPROVEMENT PLAN ENGINE
 * Genererer strategiske og operative tiltaksplaner basert på organisasjonsanalyse.
 */

export const PLAN_PHASES = {
  STABILIZE: { id: 1, range: 'Dag 1-30', title: 'Stabilisere og Prioritere', color: 'rose' },
  IMPLEMENT: { id: 2, range: 'Dag 31-60', title: 'Implementere og Engasjere', color: 'indigo' },
  ANCHOR: { id: 3, range: 'Dag 61-90', title: 'Forankre og Evaluere', color: 'emerald' }
};

export const generate90DayPlan = (metrics, companyName) => {
  const { we, ohs, cri, stress, psi, leadership, culture } = metrics;
  
  const plan = {
    company: companyName,
    executiveSummary: `Basert på en OHS på ${ohs}% og Stress-indeks på ${stress}%, kreves en strukturert 90-dagers intervensjon. Fokus er å redusere operativ belastning i fase 1, for deretter å bygge psykologisk trygghet som fundament for prestasjon i fase 2 og 3.`,
    phases: []
  };

  // FASE 1: STABILIZE (1-30)
  const phase1 = {
    ...PLAN_PHASES.STABILIZE,
    actions: [
      {
        area: 'Risikohåndtering',
        action: 'Kommunisere hovedfunn fra kartlegging til hele organisasjonen.',
        rationale: 'Sikre transparens og redusere usikkerhet/ryktedannelse.',
        responsible: 'CEO / HR-Direktør',
        deadline: 'Dag 7',
        status: 'Planlagt'
      }
    ]
  };

  if (stress > 70) {
    phase1.actions.push({
      area: 'Stressmestring',
      action: 'Gjennomføre "prioriterings-vask" i høyrisiko-avdelinger.',
      rationale: 'Umiddelbar reduksjon av kognitiv belastning for å forebygge fravær.',
      responsible: 'Linjeledere',
      deadline: 'Dag 14',
      status: 'Kritisk'
    });
  }

  if (cri > 60) {
    phase1.actions.push({
      area: 'Konflikt',
      action: 'Identifisere og starte mekling i fastlåste relasjoner.',
      rationale: 'Fjerne relasjonelle blokkeringer som hindrer daglig drift.',
      responsible: 'Ekstern Konsulent',
      deadline: 'Dag 20',
      status: 'Høy'
    });
  }

  // FASE 2: IMPLEMENT (31-60)
  const phase2 = {
    ...PLAN_PHASES.IMPLEMENT,
    actions: [
      {
        area: 'Rolleavklaring',
        action: 'Gjennomgang av ansvarsmatriser (RASCI) for lederteamet.',
        rationale: 'Redusere krysspress og beslutningsvegring.',
        responsible: 'Ledergruppe',
        deadline: 'Dag 45',
        status: 'Planlagt'
      }
    ]
  };

  if (psi < 50) {
    phase2.actions.push({
      area: 'Psykologisk Trygghet',
      action: 'Workshop-serie: "Trygghet for læring og feilhåndtering".',
      rationale: 'Bygge fundament for innovasjon og åpen ytringskultur.',
      responsible: 'Teamledere / HR',
      deadline: 'Dag 55',
      status: 'Høy'
    });
  }

  if (leadership < 55) {
    phase2.actions.push({
      area: 'Ledelse',
      action: 'Lansere 1-til-1 strukturert lederstøtte-program.',
      rationale: 'Styrke relasjonell kapasitet i operativ ledelse.',
      responsible: 'HR / Coach',
      deadline: 'Dag 40',
      status: 'Planlagt'
    });
  }

  // FASE 3: ANCHOR (61-90)
  const phase3 = {
    ...PLAN_PHASES.ANCHOR,
    actions: [
      {
        area: 'Evaluering',
        action: 'Gjennomføre ny pulsmåling på nøkkel-KPIer.',
        rationale: 'Dokumentere effekt av tiltak og justere kursen.',
        responsible: 'HR-Analyse',
        deadline: 'Dag 80',
        status: 'Planlagt'
      },
      {
        area: 'Strategisk Plan',
        action: 'Definere langsiktige mål for arbeidsmiljø i årsplanen.',
        rationale: 'Sikre at arbeidsmiljø forblir en integrert del av forretningsstrategien.',
        responsible: 'Styret / Ledelse',
        deadline: 'Dag 90',
        status: 'Strategisk'
      }
    ]
  };

  plan.phases = [phase1, phase2, phase3];
  return plan;
};

export const mockPlanInput = {
  we: 58,
  ohs: 54,
  cri: 65,
  stress: 78,
  psi: 42,
  leadership: 48,
  culture: 52
};